import {
  ActionButtonProps,
  Box,
  BoxProps,
  Button,
  ColorOptions,
  convertHexToRGBA,
  Form,
  ModBox,
  Spacer,
  SpacerNew,
  Text,
} from '@jfs/ui-new'
import { useNavigation, useRoute } from '@react-navigation/native'
import { FC, useEffect, useRef } from 'react'
import { InteractionManager, ScrollView } from 'react-native'
import { titleCase } from '../../../comps/CustomHeader/headerFunctionHelpers'
import { DefaultFormContainer } from '../../../comps/DefaultFormContainer'
import { HeaderLeft } from '../../../comps/MobileCustomHeader/HeaderLeft'
import { useLazyApiData, useStores } from '../../../data/store'
import { Routes } from '../../../nav/routes'
import { getOperatorField, TransactionStatus } from '../../../util/billPaymentUtil'
import { Colors } from '../../../util/util'
import { PoweredBy } from '../Footer/PoweredBy'
import { Logo } from '../Logo'

const AuthInput: FC = () => {
  const { getOperator, txnData, status, updateBillMeta, getBillFetch, registerBiller } = useStores((root) => ({
    allOperators: root.billPayments?.operator,
    recentData: root.billPayments?.user?.favourites,
    getOperator: root.billPayments?.getOperator,
    txnData: root.billPayments?.transaction,
    status: root.billPayments?.transaction.status,
    bill: root.billPayments?.getBill(),
    authLength: root.billPayments?.transaction.txnMetaData.bill.authenticators.length,
    updateBillMeta: root.billPayments?.updateBillfetchMetaData,
    getBillFetch: root.billPayments?.getBillFetchApi,
    registerBiller: root.billPayments?.registerBillerApi,
  }))
  const txnMetaData = txnData?.txnMetaData
  const bill = txnMetaData?.bill
  const operator = getOperator()
  const isAddBillerFlow = status === TransactionStatus.INITIATED_ADD_BILLER
  const billerCategoryMasterId = txnMetaData?.id
  const initialAuthenticators = bill?.authenticators
  const navigation = useNavigation()
  const inputRef = useRef<any>(null)

  const params: any = useRoute().params ?? {}

  navigation.setOptions({
    gestureEnabled: true,
    headerLeft: () => <HeaderLeft />,
    headerStyle: { borderBottomColor: 'rgba(0,0,0,0)' },
    headerTintColor: '#fff',
    headerBackVisible: true,
    headerTransparent: true,
    title: titleCase(params?.title ?? ''),
    headerTitleStyle: {
      fontSize: 18,
      fontFamily: 'JioType-Bold',
    },
  })

  const [getBillAPIFetchData, { state: billfetchLoading }] = useLazyApiData(getBillFetch)
  const [registerBillerApi, { state: addBillerState, data: addBillerData }] = useLazyApiData(registerBiller)

  useEffect(() => {
    if (addBillerState === 'fulfilled') {
      console.log('addBillerData success', addBillerData)
    } else if (addBillerState === 'rejected') {
      console.log('addBillerData failed', addBillerData)
    }
  }, [addBillerData, addBillerState])

  useEffect(() => {
    InteractionManager.runAfterInteractions(() => {
      inputRef?.current?.focus()
    })
  }, [])

  useEffect(() => {
    if (billfetchLoading === 'fulfilled') {
      const txn = txnData?.txnMetaData?.bill
      if (txn?.proceedPaymentFlag && txn?.proceedPaymentAlertMsg) {
        // show confirmation alert modal
        //setShowAlert({ show: true, message: bill.proceedPaymentAlertMsg })
        navigation.navigate(Routes.BILL_FETCH as never, { title: params.title } as never)
      } else {
        navigation.navigate(Routes.BILL_FETCH as never, { title: params.title } as never)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [billfetchLoading, navigation, txnData])

  const getFormFieldArray = (formData: any) => {
    const formFieldArray =
      formData?.fields.map((dataItem: any, index: number) => {
        return getOperatorField(dataItem, index, formData.fields.length, inputRef)
      }) ?? []

    // as per discussion with 'product team' disabled auto pay by default
    // const dataAry = [...formFieldArray, isAddBillerFlow && getEnableAutoPayView()].filter(
    //   (item) => item !== false && item !== null && item !== undefined,
    // )
    const dataAry = [...formFieldArray].filter((item) => item !== false && item !== null && item !== undefined)

    const retData = [
      {
        formItems: dataAry,
        verticalSpacing: 0,
        onSubmit: async () => {
          return 'end'
        },
        actionTitle: 'Save',
      },
    ]
    return retData
  }

  const getInitialValues = (dataItem: any) => {
    const initValues: { [key: string]: string } = {}
    const autheData: any = getFormFieldArray(dataItem)[0]
    const data: any = autheData.formItems
    data.forEach((item: any, index: any) => {
      const fieldName = item.fieldName
      initValues[fieldName] = initialAuthenticators[index] ?? ''
    })
    return initValues
  }

  const getList = (objData: any, orderId?: any) => {
    // TODO: few order id's we have to pass the amount into the authendicators list
    // as per discussion for all the biller type the amount will be listed in authndicators list.
    // removed (item[0] !== 'Amount' || orderId === 500010 || orderId === 500011)
    return Object.entries(objData)
      .filter((item) => item[0] !== 'Nickname')
      .map((item) => {
        return item[1]
      })
  }
  const getLabelList = (objData: any) => {
    return Object.entries(objData)
      .filter((item) => item[0] !== 'Nickname' && item[0] !== 'Amount')
      .map((item) => {
        return item[0]
      })
  }

  const renderActionButton = ({ isValid, values }: ActionButtonProps) => {
    const updateMeta = async () => {
      await updateBillMeta({
        billerCategoryMasterId,
        billerMasterId: operator?.id,
        authenticators: getList(values, operator?.id),
        shortName: values.Nickname ?? '',
        amount: values.Amount ?? null,
        labelOfAuthenticators: getLabelList(values),
      })
      if (isAddBillerFlow) {
        // call save bill api
        registerBillerApi()
      } else {
        getBillAPIFetchData()
      }
    }

    return (
      <Box {...styles.buttonProceed} testID="buttonWithNote">
        <Box {...styles.proceedBtn}>
          <SpacerNew size={30} direction="vertical" />
          <Button
            height={50}
            isRound
            testID={'FormProceed'}
            disabled={!isValid}
            onPress={updateMeta}
            type="primary"
            isFull={true}
            color="PRIMARY"
            isLoading={isLoading}
            underlayColor="PRIMARY">
            <Text fontSize={16} color="WHITE" fontFamily="JioType-Bold">
              {'Fetch Bill Details'}
            </Text>
          </Button>
          <SpacerNew size={30} direction="vertical" />
        </Box>
      </Box>
    )
  }

  const isLoading = billfetchLoading === 'pending'

  // console.log('operator', JSON.parse(JSON.stringify(operator)))
  return (
    <Box flex={1} backgroundColor="SECONDARY" position={'relative'} pt={70}>
      <Box {...styles.listWrapper} p={0}>
        <ModBox
          flexDirection={'row'}
          width={'100%'}
          align="center"
          justify="space-between"
          show={operator?.name?.length}
          bg={convertHexToRGBA(Colors.PRIMARY, 8) as ColorOptions}
          p={25}>
          <Box align="center" flexDirection={'row'} f={0.8} pr={16}>
            <Box width={40} justifyContent="center" alignContent="center">
              <Logo logo={operator?.logoPath ?? ''} type="medium" />
            </Box>
            <Box marginHorizontal={10}>
              <Text fontFamily="JioType-Medium" lineHeight={20}>
                {operator?.shortName}
              </Text>
              {/* <Text fontSize={12} lineHeight={16} fontFamily="JioType-Medium" color={Colors.PRIMARY_GREY}>
                {operator?.name}
              </Text> */}
            </Box>
          </Box>

          <Box
            f={0.2}
            align="flex-end"
            justify="flex-end"
            testID="change-operator"
            onPress={() => navigation?.goBack()}
            underlayColor="TRANSPARENT">
            <Text fontFamily="JioType-Medium" lineHeight={20} fontSize={14} color="PRIMARY">
              Change
            </Text>
          </Box>
        </ModBox>
        <ScrollView
          keyboardShouldPersistTaps={'handled'}
          contentContainerStyle={{ flexGrow: 1, backgroundColor: '#fff', paddingHorizontal: 25 }}
          nestedScrollEnabled={true}>
          <ModBox f={1}>
            <Spacer direction="vertical" size={25} />
            <Form
              container={DefaultFormContainer}
              formData={getFormFieldArray(operator) as any}
              actionButtons={renderActionButton as any}
              initialValues={getInitialValues(operator)}
            />
            <Spacer direction="vertical" size={25} />
          </ModBox>
        </ScrollView>
        <Box backgroundColor={convertHexToRGBA('#000', 3) as ColorOptions}>
          <PoweredBy />
        </Box>
      </Box>
    </Box>
  )
}

const styles = {
  listWrapper: {
    flex: 1,
    backgroundColor: 'WHITE',
    padding: 24,
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    width: '100%',
    zIndex: 4,
    overflow: 'auto',
  } as BoxProps,
  underlay: '#F0F0F0',
  formContainer: {
    backgroundColor: 'WHITE',
  } as BoxProps,
  buttonProceed: {
    f: 1,
  } as BoxProps,
  proceedBtn: {
    // position: 'absolute',
    // bottom: 0,
    // width: '100%',
    // backgroundColor: 'WHITE',
    // flex: 1,
    // justifyContent: 'flex-end',
  } as BoxProps,
}

export default AuthInput
